//ProfilLibrary.js



import * as THREE from "three";


var matShape = new THREE.MeshBasicMaterial({color:"blue"});


function IPE(id, height, width, webThickness, flangeThickness) {
	this.id = id;
	this.height = height;
	this.width = width;
	this.webThickness = webThickness;
	this.flangeThickness = flangeThickness
}

function HEB(id, height, width, webThickness, flangeThickness) {
	this.id = id;
	this.height = height;
	this.width = width;
	this.webThickness = webThickness;
	this.flangeThickness = flangeThickness
}

var IPEProfiles = [
	new IPE ( "IPE 160", 160, 82,  5,    7.4  ),
	new IPE ( "IPE 180", 180, 91,  5.3,  8    ),
	new IPE ( "IPE 200", 200, 100, 5.6,  8.5  ),
	new IPE ( "IPE 220", 220, 110, 5.9,  9.2  ),
	new IPE ( "IPE 240", 240, 120, 6.2,  9.8  ),
	new IPE ( "IPE 270", 270, 135, 6.6,  10.2 ),
	new IPE ( "IPE 300", 300, 150, 7.1,  10.7 ),
	new IPE ( "IPE 330", 330, 160, 7.5,  11.5 ),
	new IPE ( "IPE 360", 360, 170, 8,    12.7 ),
	new IPE ( "IPE 400", 400, 180, 8.6,  13.5 ),
	new IPE ( "IPE 450", 450, 190, 9.4,  14.6 ),
	new IPE ( "IPE 500", 500, 200, 10.2, 16   ),
	new IPE ( "IPE 550", 550, 210, 11.1, 17.2 ),
	new IPE ( "IPE 600", 600, 220, 12,   19   )
]

var HEBProfiles = [
	new HEB ( "HEB 160",  160,  160,  8,    13   ),
	new HEB ( "HEB 180",  180,  180,  8.5,  14   ),
	new HEB ( "HEB 200",  200,  200,  9,    15   ),
	new HEB ( "HEB 220",  220,  220,  9.5,  16   ),
	new HEB ( "HEB 240",  240,  240,  10,   17   ),
	new HEB ( "HEB 260",  260,  260,  10,   17.5 ),
	new HEB ( "HEB 280",  280,  280,  10.5, 18   ),
	new HEB ( "HEB 300",  300,  300,  11,   19   ),
	new HEB ( "HEB 320",  320,  300,  11.5, 20.5 ),
	new HEB ( "HEB 340",  340,  300,  12,   21.5 ),
	new HEB ( "HEB 360",  360,  300,  12.5, 22.5 ),
	new HEB ( "HEB 400",  400,  300,  13.5, 24   ),
	new HEB ( "HEB 450",  450,  300,  14,   26   ),
	new HEB ( "HEB 500",  500,  300,  14.5, 28   ),
	new HEB ( "HEB 550",  550,  300,  15,   29   ),
	new HEB ( "HEB 600",  600,  300,  15.5, 30   ),
	new HEB ( "HEB 650",  650,  300,  16,   31   ),
	new HEB ( "HEB 700",  700,  300,  17,   32   ),
	new HEB ( "HEB 800",  800,  300,  17.5, 33   ),
	new HEB ( "HEB 900",  900,  300,  18.5, 35   ),
	new HEB ( "HEB 1000", 1600, 300,  19,   36   ),
]


//IPE
//------------------------------------------------------------------------
var IPEMeshes = [];
var IPEShapes = [];

for (let i = 0; i < IPEProfiles.length; i++) {
	var ipeVertices = getStandingProfilVertices(IPEProfiles[i]);
	var ipeShape = new THREE.Shape(ipeVertices);
	var ipeGeometry = new THREE.ShapeBufferGeometry(ipeShape);
	var ipeMesh = new THREE.Mesh(ipeGeometry, matShape);	
	IPEShapes.push(ipeShape);
	IPEMeshes.push(ipeMesh);
}



//HEB
//------------------------------------------------------------------------
var HEBMeshes = [];
var HEBShapes = [];

for (let i = 0; i < HEBProfiles.length; i++) {
	var hebVertices = getLyingProfilVertices(HEBProfiles[i]);
	var hebShape = new THREE.Shape(hebVertices);
	var hebGeometry = new THREE.ShapeBufferGeometry(hebShape);
	var hebMesh = new THREE.Mesh(hebGeometry, matShape);	
	HEBShapes.push(hebShape);
	HEBMeshes.push(hebMesh);
}




//------------------------------------------------------------------------
//Functions
//------------------------------------------------------------------------



//------------------------------------------------------------------------
//This function gets the vertices for a lying profil
//------------------------------------------------------------------------
function getLyingProfilVertices (profil) {

	var h = profil.height/1000;
	var b = profil.width/1000;
	var tw = profil.webThickness/1000;
	var tf = profil.flangeThickness/1000;
	var vertices = [
					new THREE.Vector2( -(b/2),  -(h/2)      ),	//Pt 1
					new THREE.Vector2( -(b/2),  -(h/2 - tf) ),	//Pt 2
					new THREE.Vector2( -(tw/2), -(h/2 - tf) ),	//Pt 3
					new THREE.Vector2( -(tw/2),  (h/2 - tf) ),	//Pt 4
					new THREE.Vector2( -(b/2),   (h/2 - tf) ),	//Pt 5
					new THREE.Vector2( -(b/2),   (h/2)      ),	//Pt 6
					new THREE.Vector2(  (b/2),   (h/2)      ),	//Pt 7
					new THREE.Vector2(  (b/2),   (h/2 - tf) ),	//Pt 8
					new THREE.Vector2(  (tw/2),  (h/2 - tf) ),	//Pt 9
					new THREE.Vector2(  (tw/2), -(h/2 - tf) ),	//Pt 10
					new THREE.Vector2(  (b/2),  -(h/2 - tf) ),	//Pt 11
					new THREE.Vector2( (b/2),   -(h/2)      ),	//Pt 12
					new THREE.Vector2( -(b/2),  -(h/2)      )	//Pt 13
	];

	return vertices; 
}



//------------------------------------------------------------------------
//This function gets the vertices for a standing profil
//------------------------------------------------------------------------
function getStandingProfilVertices (profil) {

	var h = profil.height/1000;
	var b = profil.width/1000;
	var tw = profil.webThickness/1000;
	var tf = profil.flangeThickness/1000;
	var vertices = [
					new THREE.Vector2( -(h/2),       -(b/2)  ),	//Pt 1
					new THREE.Vector2( -(h/2 - tf),  -(b/2)  ),	//Pt 2
					new THREE.Vector2( -(h/2 - tf),  -(tw/2) ),	//Pt 3
					new THREE.Vector2(  (h/2 - tf),  -(tw/2) ),	//Pt 4
					new THREE.Vector2(  (h/2 - tf),  -(b/2)  ),	//Pt 5
					new THREE.Vector2(  (h/2) ,      -(b/2)  ),	//Pt 6
					new THREE.Vector2(  (h/2),        (b/2)  ),	//Pt 7
					new THREE.Vector2(  (h/2 - tf) ,  (b/2)  ),	//Pt 8
					new THREE.Vector2(  (h/2 - tf),   (tw/2) ),	//Pt 9
					new THREE.Vector2( -(h/2 - tf),   (tw/2) ),	//Pt 10
					new THREE.Vector2( -(h/2 - tf),   (b/2)  ),	//Pt 11
					new THREE.Vector2( -(h/2) ,       (b/2)  ),	//Pt 12
					new THREE.Vector2( -(h/2),       -(b/2)  )  //Pt 13
	];

	return vertices; 
}


//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export { IPEMeshes, IPEShapes, HEBMeshes, HEBShapes }
